module.exports = [{"name":"space","host":"thalida.space","description":"A space only flavor of thalida.com"},{"name":"codes","host":"thalida.codes","description":"A code centric flavor of thalida.com"},{"name":"design","host":"thalida.design","description":"A design centric flavor of thalida.com"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/flavors.json
// module id = vQ92
// module chunks = 1